const invitation = {
  title: '邀约',
  create_target: '发起定向邀约',
  create_target_soon: '即将跳转 TikTok Shop 创建 Target Collab',
  cleanup: '清理定向邀约',
  merge_groups: '合并邀约组',
  add_talent: '添加达人',
  remove_talent: '移除达人',
  remove_talent_soon: '从所选邀约移除达人',
  remove_talent_title: '移除未接受达人',
  remove_talent_hint: '先读取邀约详情里的达人。已接受、未接受来自达人信息的收藏标签。提交后接口仍可能跳过并返回原因。',
  label_accepted: '已接受',
  label_unaccepted: '未接受',
  label_ordered: '已出单',
  remove_talent_failed: '移除达人失败',
  remove_talent_success: '已提交移除达人',
  remove_no_unaccepted: '当前暂无未接受邀约达人',
  cleanup_remove_none: '没有可移除的达人',
  add_product: '添加商品',
  kaloboost_hint: '参照 Kaloboost：邀约以店铺侧 Target Collab 为准，不走私信额度',
  status_tabs: '邀约状态',
  col_name: '邀约名称（TikTok Shop）',
  col_status: '状态',
  col_product: '商品',
  col_deadline: '截止日期',
  col_added: '已添加达人',
  col_accepted: '已接受',
  col_fulfilled: '已履约',
  col_actions: '操作',
  filter_all: '全部',
  name_placeholder: '搜索邀约名称',
  submit_status: '提交状态',
  filter_ongoing: '进行中',
  filter_closed: '已截止',
  filter_cancelled: '已取消',
  status_expiring: '即将到期',
  status_valid: '有效',
  status_canceling: '取消中',
  status_completed: '已完成',
  submit_submitting: '提交中',
  submit_success: '提交成功',
  submit_failed: '提交失败',
  submit_unknown: '未知',
  load_failed: '邀约列表加载失败',
  batch_invite_hint: '最多 10 条邀约。黑名单和已在邀约中的达人会跳过。',
  invite_shop_required: '请先选择店铺',
  invite_pick_required: '请选择邀约',
  invite_options_failed: '邀约列表加载失败',
  invite_success: '已提交批量邀约',
  invite_failed: '批量邀约失败',
  refreshed: '已刷新店铺商品列表',
  pick_product: '请至少选择一件商品',
  product_list_unavailable: '商品列表接口尚未接入',
  add_products_failed: '添加商品失败',
  add_products_success: '商品已添加',
  add_products_limit: '最多选择 10 条邀约',
  invite_limit: '最多选择 10 条邀约',
  target_named: '「{{name}}」',
  target_current: '当前邀约',
  added_products: '已添加 {{count}} 件商品至{{target}}',
  add_product_title: '添加商品到邀约',
  product_hint: '仅当前授权店铺可售商品。佣金默认公开邀约比例，可按定向邀约调整。',
  current_shop: '当前店',
  rate_adjustable: '佣金默认公开邀约比例，可调整',
  refresh: '刷新',
  public_rate: '{{sku}} · {{price}} · 公开邀约 {{rate}}%',
  target_commission: '定向佣金',
  has_email: '有邮箱',
  no_email: '无邮箱',
  pick_talent: '请至少选择一位达人',
  added_talents: '已添加 {{count}} 位达人至{{target}}',
  add_talent_title: '添加达人到邀约',
  add: '添加',
  talent_hint: '优先从「我的达人」勾选。自动跳过黑名单 / 已在邀约中 / 撞单锁定。',
  none_selected: '尚未选择达人。从「我的达人」勾选，或搜索广场按需添加。',
  selected_count: '已选 {{count}} 位达人',
  selected_named: '已选 {{count}} 位达人 · {{name}}',
  search_placeholder: '搜索我的达人，或输入昵称 / @handle 搜广场',
  my_talents: '我的达人 ({{count}})',
  search_square: '搜索广场',
  paste_list: '粘贴名单',
  select_all: '全选当前结果',
  paste_placeholder: '每行一个昵称或 @handle',
  square_prompt: '输入昵称或 @handle 搜索广场达人',
  no_match: '无匹配达人',
  mode_clear_title: '清理未接受达人并取消空邀约',
  mode_clear_desc: '只移除未接受的达人。已接受保留。商品被清空且 0 接受的邀约自动取消。',
  mode_cancel_title: '取消邀约计划',
  mode_cancel_desc: '即便已有达人接受，也会结束整条 Target Collab。需二次确认。',
  cleaned: '已执行清理：{{mode}}',
  cleaned_whitelist: '已执行清理：{{mode}}（白名单 {{count}} 人）',
  confirm_cancel_title: '确认取消邀约计划？',
  confirm_cancel_content: '即便已有达人接受，也会结束整条 Target Collab。此操作不可撤销。',
  confirm_cancel_ok: '确认取消',
  confirm_cancel_back: '返回',
  cancel_plan_failed: '取消邀约计划失败',
  cancel_plan_success: '已取消邀约计划',
  run_cleanup: '执行清理',
  choose_method: '选择清理方式',
  whitelist_title: '不清理的达人（白名单）',
  whitelist_summary: '白名单已选 {{count}} 位达人（清理时将保留）',
  stat_added: '已添加',
  deadline_at: '截止 {{date}}',
  talents: '达人',
  accepted_note: '接受后进履约；',
  pending_note: '未接受可清理。不占用私信额度。',
  detail_title: '邀约详情',
  detail_load_failed: '邀约详情加载失败',
  detail_empty: '暂无邀约详情',
  detail_empty_talents: '暂无达人',
  detail_content_products: '内容商品',
  detail_empty_products: '暂无挂载商品',
  detail_empty_operations: '暂无操作记录',
  detail_sync_pending: '详情回读未完成，下面的数量可能还不是平台当前状态。',
  detail_failed_reason: '失败原因',
  detail_submit_failed: '提交失败：{{reason}}',
  detail_shop_id: '店铺id',
  detail_deadline: '截止时间',
  detail_free_sample: '免费样品',
  detail_sample_exempt: '免审',
  detail_content_type: '内容类型',
  detail_operations: '操作记录',
  detail_op_failed: '最近一次操作失败',
  detail_request_id: '平台请求号',
  detail_yes: '是',
  detail_no: '否',
  pick_primary: '请选择主邀约',
  pick_deadline: '请选择合并后截止日期',
  pick_two: '请至少选择 2 条进行中且未锁定的邀约',
  merged: '已合并 {{count}} 条邀约至「{{name}}」，截止 {{date}}',
  merge_failed: '合并邀约失败',
  merge_success: '邀约已合并',
  merge_end_invalid: '截止日期必须晚于当前时间',
  merge: '合并',
  merge_hint: '将多条进行中且未锁定的定向邀约合并为一条，达人与商品去重后写入主邀约。',
  too_few: '所选邀约中需至少包含 2 条「进行中」且未锁定的邀约方可合并。',
  primary: '主邀约',
  primary_placeholder: '选择主邀约',
  deadline_after: '合并后截止日期',
  channel_email: '平台邮箱',
  channel_dm: '私信',
  script_sample: '新品试样',
  script_invite: '定向邀约',
  script_follow: '跟进回复',
  outreach_created: '已创建建联任务（{{count}} 人）',
  outreach_title: '快速建联',
  create_task: '创建任务',
  task_name: '任务名称',
  task_name_placeholder: '不填则使用「邮件任务」',
  mail_subject: '邮件主题',
  mail_subject_placeholder: '请输入邮件主题',
  mail_body: '邮件正文',
  mail_body_placeholder: '请输入邮件正文',
  template_placeholder: '可选，仅当前店铺的邮件话术',
  template_load_failed: '话术模板加载失败',
  campaign_subject_required: '请填写邮件主题',
  campaign_body_required: '请填写邮件正文',
  campaign_no_email: '所选达人没有邮箱，无法创建邮件任务',
  campaign_skipped_email: '已跳过 {{count}} 位没有邮箱的达人',
  campaign_failed: '邮件任务创建失败',
  campaign_created: '邮件任务已创建',
  dm_failed: '私信会话创建失败',
  dm_missing_conversation: '未返回会话编号',
  dm_created: '私信会话已创建',
  channel: '渠道',
  script_or_invite: '话术 / 邀约',
  select_talent: '选择达人',
  all_count: '全部 ({{count}})',
  empty_selected: '暂无已选达人，请从其他 Tab 勾选',
  batch_count: '批量 {{count}} 人',
  joined: '已加入定向邀约：{{name}}',
  join_title: '加入定向邀约',
  join_title_named: '加入定向邀约 · {{name}}',
  invite: '邀约',
  target_hint: '写入当前店 Target Collab。过黑名单与撞单锁。',
  invite_list: '邀约列表',
  invite_list_placeholder: '请选择邀约',
  create_name: '邀约名称',
  create_name_placeholder: '例：VN 维C精华 · 10月定向',
  create_deadline: '截止日期',
  mounted_products: '挂载商品',
  product_load_failed: '店铺商品加载失败',
  product_pick_invite: '请先选择邀约',
  product_empty: '当前店铺暂无可售商品',
  product_keyword: '搜索商品名称',
  product_refreshed: '已刷新店铺商品',
  add_talent_section: '添加达人（可从我的达人快捷勾选）',
  talent_default_hint: '默认只用「我的达人」。广场请搜索添加，不会加载全部达人。',
  submit_invite: '提交邀约',
  submit_invite_note:
    '提交后创建 TikTok Shop Target Collab。达人在 Seller / 联盟侧看到邀约，接受后进入履约。店铺需已完成授权。黑名单达人不会出现在名单中。',
  create_name_required: '请填写邀约名称',
  create_deadline_required: '请选择截止日期',
  contact_email: '联系人邮箱',
  contact_email_placeholder: '请输入联系人邮箱',
  contact_email_required: '请填写联系人邮箱',
  invite_message: '邀约消息',
  invite_message_placeholder: '选填',
  commission_required: '请填写不小于 0 的定向佣金',
  product_id_invalid: '商品 ID 不能为空，且不能超过 64 个字符',
  create_failed: '创建定向邀约失败',
  create_success: '定向邀约已创建',
  create_skipped: '已跳过 {{count}} 位达人'
};

export default invitation;
